import { type CarDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/mvp';
import { ListBox, Table } from '@flos/react-ui';
import TableRow from '../../../shared_components/TableRow/TableRow';
import { type RowInformation } from '../../../config/flavourConfig';
import { useHippoText } from '../../../hooks/useHippoText';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsMvpMilage = ({
    carCoverable
}: {
    carCoverable: CarDTO;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = isMobileDevice;
    const getHippoText = useHippoText();

    const componentProperties = {
        title: getHippoText('DSS-COVERABLE-DETAILS-KILOMETER-CONSUMPTION-HEADER'),
        rowsInformation: [
            {
                name: getHippoText('DSS-COVERABLE-DETAILS-MILEAGE-SUBHEADER'),
                fieldValue: `${carCoverable.yearlyMileage} km`
            }
        ]
    };

    if (carCoverable.hideMileageRelatedAttribute) {
        return <></>;
    }

    return (
        <div id="mvp-milage-container" className="u-spacing-inset-m--stretch-max">
            <ListBox title={componentProperties?.title ?? ''} isOpen={!listBoxIsOpen}>
                <Table mobileDirection="horizontal" className="u-spacing-stack-sm">
                    <Table.Body>
                        {componentProperties.rowsInformation.map((rowInfo: RowInformation) => {
                            return <TableRow key={rowInfo.name} rowInfo={rowInfo} />;
                        })}
                    </Table.Body>
                </Table>
            </ListBox>
        </div>
    );
};

export default CoverableDetailsMvpMilage;
